"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactUse = require("react-use");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _LinkButton = _interopRequireDefault(require("./LinkButton"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    icon: {
      marginRight: spacing(1),
      fontSize: 'inherit'
    },
    copyLink: function copyLink(_ref2) {
      var fontSize = _ref2.fontSize;
      return {
        fontSize: "".concat(fontSize, "rem"),
        marginLeft: spacing(2)
      };
    }
  };
});
/**
 * One-click copy button
 *
 * @function
 * @param {object}   props
 * @param {string}   props.value           Value to copy
 * @param {string}   props.title           Button text
 * @param {number}   props.fontSize        Icon and font size in rem
 * @returns {React.ReactElement}
 */

var CopyToClipboardButton = function CopyToClipboardButton(_ref3) {
  var value = _ref3.value,
      title = _ref3.title,
      fontSize = _ref3.fontSize;
  var classes = useStyles({
    fontSize: fontSize
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var copyToClipboard = (0, _reactUse.useCopyToClipboard)()[1]; // eslint-disable-next-line require-jsdoc

  var handleClose = function handleClose() {
    return setOpen(false);
  }; // eslint-disable-next-line require-jsdoc


  var handleOpen = function handleOpen() {
    return setOpen(true);
  };

  var copyValue = (0, _react.useCallback)(function () {
    handleOpen();
    copyToClipboard(value);
    setTimeout(function () {
      return handleClose();
    }, 800);
  }, [copyToClipboard, value]);
  return /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    PopperProps: {
      disablePortal: true
    },
    onClose: handleClose,
    disableFocusListener: true,
    disableHoverListener: true,
    disableTouchListener: true,
    open: open,
    onOpen: handleOpen,
    title: "Copied!",
    interactive: true
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_LinkButton["default"], {
    className: classes.copyLink,
    onClick: function onClick() {
      return copyValue();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "copy",
    color: "link",
    className: classes.icon
  }), title)));
};

CopyToClipboardButton.propTypes = {
  value: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fontSize: _propTypes["default"].number
};
CopyToClipboardButton.defaultProps = {
  title: undefined,
  fontSize: 1
};
var _default = CopyToClipboardButton;
exports["default"] = _default;